import React, { useState, useRef, useEffect, use } from 'react';
import Matches from './DropDown/Matches';
import MessageAppointment from './DropDown/MessageAppointment';
import InMatchAppointment from './DropDown/InMatchAppointment';
import AdminResponse from './DropDown/AdminResponse';
import Approval from './DropDown/Approval';
import ParticipantJoin from './DropDown/ParticipantJoin';

import AdminMatchReport from './DropDown/AdminMatchReport';
import AdminUserReport from './DropDown/AdminUserReport';

import { updateNotification } from '@/lib/api/Notifications';



const NotificationDropdown = ({ notifications }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [readNotifications, setReadNotifications] = useState(new Set());
    const [filter, setFilter] = useState('all');
    const dropdownRef = useRef(null);

    const { is_admin, account_type } = notifications || {};

    // Determine which notification types are allowed
    const allowedTypes =
        account_type === 'sport_organizer' && !is_admin
            ? ['approval', 'participant_join']
            : [
                'matches',
                'message_appointment',
                'in_match_appointment',
                'approval',
                'participant_join',
                'admin_warning',
                'admin_ban',
                ...(is_admin ? ['match_report', 'user_report'] : [])
            ];

    useEffect(() => {






        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleMarkAsRead = async (id) => {
        try {
            await updateNotification(id); // send only the notification_id to backend
            setReadNotifications((prev) => new Set(prev).add(id)); // update local state
        } catch (err) {
            console.error("Failed to update notification:", err);
        }
    };

    // Count unread notifications only for allowed types
    const unreadCount = allowedTypes.flatMap((type) => {
        if (type === 'admin_warning') {
            return Array.isArray(notifications.admin_response?.admin_warning)
                ? notifications.admin_response.admin_warning
                : [];
        }
        if (type === 'admin_ban') {
            return Array.isArray(notifications.admin_response?.admin_ban)
                ? notifications.admin_response.admin_ban
                : [];
        }
        return Array.isArray(notifications[type]) ? notifications[type] : [];
    }).filter((n) => !n.is_read && !readNotifications.has(n.notification_id)).length;

    const shouldShow = (notifArray, type) => {
        return filter === type || (filter === 'all' && notifArray?.length > 0);
    };

    const renderLabel = (notifArray, label) => {
        return filter !== 'all' || (notifArray?.length > 0) ? (
            <div style={{ fontWeight: 'bold', marginTop: '12px', marginBottom: '8px' }}>{label}</div>
        ) : null;
    };

    return (
        <div className="position-relative" ref={dropdownRef}>
            <button
                onClick={() => setShowDropdown(prev => !prev)}
                className="bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center border-0 position-relative"
                style={{ width: '36px', height: '36px', fontWeight: 'bold', cursor: 'pointer' }}
                aria-label="Notifications"
            >
                🔔
                {unreadCount > 0 && (
                    <span
                        style={{
                            position: 'absolute',
                            top: '2px',
                            right: '2px',
                            background: 'red',
                            color: 'white',
                            fontSize: '0.7rem',
                            borderRadius: '50%',
                            padding: '2px 6px',
                            fontWeight: 'bold'
                        }}
                    >
                        {unreadCount}
                    </span>
                )}
            </button>

            {showDropdown && (
                <div
                    className="position-absolute"
                    style={{
                        top: '42px',
                        right: 0,
                        left: 'auto',
                        width: '90vw',
                        maxWidth: '480px',
                        maxHeight: '70vh',
                        background: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: '6px',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                        zIndex: 1000,
                        display: 'flex',
                        flexDirection: 'column',
                        overflowY: 'auto',
                        color: '#000', // ✅ ensure text is visible

                        // Mobile centering
                        ...(window.innerWidth <= 768
                            ? {
                                left: '50%',
                                right: 'auto',
                                transform: 'translateX(-50%)',
                            }
                            : {}),
                    }}

                >
                    {is_admin ? (


                        <>



                            {/* Sticky Filter */}
                            <div
                                style={{
                                    padding: '12px',
                                    borderBottom: '1px solid #ccc',
                                    background: '#fff',
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 10
                                }}
                            >
                                <select
                                    value={filter}
                                    onChange={(e) => setFilter(e.target.value)}
                                    style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '0.95rem', cursor: 'pointer', background: '#fff' }}
                                >
                                    <option value="all">All Notifications</option>

                                    {allowedTypes.includes('match_report') && <option value="match_report">Match Reports</option>}
                                    {allowedTypes.includes('user_report') && <option value="user_report">User Reports</option>}


                                </select>
                            </div>

                            <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {/* Match Reports */}
                                {allowedTypes.includes('match_report') && (filter === 'all' || filter === 'match_report') && (
                                    <>
                                        <div style={{ fontWeight: 'bold', marginTop: '12px', marginBottom: '8px' }}>Match Report Notifications</div>
                                        {notifications.match_report && notifications.match_report.length > 0 ? (
                                            <AdminMatchReport
                                                reports={notifications.match_report}
                                                readNotifications={readNotifications}
                                                setReadNotifications={setReadNotifications}
                                                onMarkAsRead={handleMarkAsRead}

                                            />
                                        ) : (
                                            <div style={{ padding: '10px', color: '#a76464ff' }}>No Match Report notifications</div>
                                        )}
                                    </>
                                )}

                                {/* User Reports */}
                                {allowedTypes.includes('user_report') && (filter === 'all' || filter === 'user_report') && (
                                    <>
                                        <div style={{ fontWeight: 'bold', marginTop: '12px', marginBottom: '8px' }}>User Report Notifications</div>
                                        {notifications.user_report && notifications.user_report.length > 0 ? (
                                            <AdminUserReport
                                                reports={notifications.user_report}
                                                readNotifications={readNotifications}
                                                setReadNotifications={setReadNotifications}
                                                onMarkAsRead={handleMarkAsRead}

                                            />
                                        ) : (
                                            <div style={{ padding: '10px', color: '#666' }}>No User Report notifications</div>
                                        )}
                                    </>
                                )}
                            </div>




                        </>




                    ) : (
                        <>
                            {/* Sticky Filter */}
                            <div
                                style={{
                                    padding: '12px',
                                    borderBottom: '1px solid #ccc',
                                    background: '#fff',
                                    position: 'sticky',
                                    top: 0,
                                    zIndex: 10
                                }}
                            >
                                <select
                                    value={filter}
                                    onChange={(e) => setFilter(e.target.value)}
                                    style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '0.95rem', cursor: 'pointer', background: '#fff' }}
                                >
                                    <option value="all">All Notifications</option>
                                    {allowedTypes.includes('match_report') && <option value="match_report">Match Reports</option>}
                                    {allowedTypes.includes('user_report') && <option value="user_report">User Reports</option>}

                                    {allowedTypes.includes('matches') && <option value="matches">Matches</option>}
                                    {allowedTypes.includes('message_appointment') && <option value="message_appointment">Message Appointments</option>}
                                    {allowedTypes.includes('in_match_appointment') && <option value="in_match_appointment">In-Match Appointments</option>}
                                    {allowedTypes.includes('approval') && <option value="approval">Approvals</option>}
                                    {allowedTypes.includes('participant_join') && <option value="participant_join">Participant Joins</option>}
                                    {allowedTypes.includes('admin_warning') || allowedTypes.includes('admin_ban') ? (
                                        <optgroup label="Admin">
                                            {allowedTypes.includes('admin_warning') && <option value="admin_warning">Warnings</option>}
                                            {allowedTypes.includes('admin_ban') && <option value="admin_ban">Bans</option>}
                                        </optgroup>
                                    ) : null}


                                </select>
                            </div>

                            {/* Notifications Container */}
                            <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                {/* Check if there is any notification at all */}
                                {[
                                    notifications.matches,
                                    notifications.message_appointment,
                                    notifications.in_match_appointment,
                                    notifications.approval,
                                    notifications.participant_join,
                                    notifications.admin_response?.admin_warning,
                                    notifications.admin_response?.admin_ban
                                ].every(arr => !arr || arr.length === 0) && filter === 'all' && (
                                        <div style={{ padding: '10px', textAlign: 'center', color: '#666', fontWeight: '500' }}>
                                            No notifications yet
                                        </div>
                                    )}

                                {/* Matches */}
                                {allowedTypes.includes('matches') &&
                                    ((filter === 'matches') || (filter === 'all' && notifications.matches?.length > 0)) && (
                                        <>
                                            {(filter !== 'all' || (notifications.matches?.length > 0)) && (
                                                <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Match Notifications</div>
                                            )}
                                            <Matches
                                                matches={notifications.matches}
                                                readNotifications={readNotifications}
                                                setReadNotifications={setReadNotifications}
                                                onMarkAsRead={handleMarkAsRead}
                                            />
                                        </>
                                    )}

                                {/* Message Appointments */}
                                {allowedTypes.includes('message_appointment') &&
                                    ((filter === 'message_appointment') || (filter === 'all' && notifications.message_appointment?.length > 0)) && (
                                        <>
                                            {(filter !== 'all' || (notifications.message_appointment?.length > 0)) && (
                                                <div style={{ fontWeight: 'bold', marginTop: '12px', marginBottom: '8px' }}>
                                                    Message Appointment Notifications
                                                </div>
                                            )}
                                            <MessageAppointment
                                                appointments={notifications.message_appointment}
                                                readNotifications={readNotifications}
                                                setReadNotifications={setReadNotifications}
                                                onMarkAsRead={handleMarkAsRead}
                                            />
                                        </>
                                    )}

                                {/* In-Match Appointments */}
                                {allowedTypes.includes('in_match_appointment') &&
                                    ((filter === 'in_match_appointment') || (filter === 'all' && notifications.in_match_appointment?.length > 0)) && (
                                        <>
                                            {(filter !== 'all' || (notifications.in_match_appointment?.length > 0)) && (
                                                <div style={{ fontWeight: 'bold', marginTop: '12px', marginBottom: '8px' }}>
                                                    In-Match Appointment Notifications
                                                </div>
                                            )}
                                            <InMatchAppointment
                                                appointments={notifications.in_match_appointment}
                                                readNotifications={readNotifications}
                                                setReadNotifications={setReadNotifications}
                                                onMarkAsRead={handleMarkAsRead}
                                            />
                                        </>
                                    )}

                                {/* Approvals */}
                                {allowedTypes.includes('approval') &&
                                    ((filter === 'approval') || (filter === 'all' && notifications.approval?.length > 0)) && (
                                        <>
                                            {(filter !== 'all' || (notifications.approval?.length > 0)) && (
                                                <div style={{ fontWeight: 'bold', marginTop: '12px', marginBottom: '8px' }}>
                                                    Approval Notifications
                                                </div>
                                            )}
                                            {notifications.approval?.length > 0 ? (
                                                <Approval
                                                    approvals={notifications.approval}
                                                    readNotifications={readNotifications}
                                                    setReadNotifications={setReadNotifications}
                                                    onMarkAsRead={handleMarkAsRead}
                                                />
                                            ) : (
                                                filter !== 'all' && (
                                                    <div style={{ padding: '10px', color: '#666' }}>No approval notifications</div>
                                                )
                                            )}
                                        </>
                                    )}

                                {/* Participant Joins */}
                                {allowedTypes.includes('participant_join') &&
                                    ((filter === 'participant_join') || (filter === 'all' && notifications.participant_join?.length > 0)) && (
                                        <>
                                            {(filter !== 'all' || (notifications.participant_join?.length > 0)) && (
                                                <div style={{ fontWeight: 'bold', marginTop: '12px', marginBottom: '8px' }}>
                                                    Participant Join Notifications
                                                </div>
                                            )}
                                            <ParticipantJoin
                                                participants={Array.isArray(notifications.participant_join) ? notifications.participant_join : []}
                                                readNotifications={readNotifications}
                                                setReadNotifications={setReadNotifications}
                                                onMarkAsRead={handleMarkAsRead}
                                            />
                                        </>
                                    )}

                                {/* Admin Warnings */}
                                {allowedTypes.includes('admin_warning') &&
                                    ((filter === 'admin_warning') || (filter === 'all' && notifications.admin_response?.admin_warning?.length > 0)) && (
                                        <>
                                            {(filter !== 'all' || (notifications.admin_response?.admin_warning?.length > 0)) && (
                                                <div style={{ fontWeight: 'bold', marginTop: '12px', marginBottom: '8px' }}>
                                                    Admin Warnings
                                                </div>
                                            )}
                                            <AdminResponse
                                                responses={notifications.admin_response?.admin_warning}
                                                readNotifications={readNotifications}
                                                setReadNotifications={setReadNotifications}
                                                onMarkAsRead={handleMarkAsRead}
                                            />
                                        </>
                                    )}

                                {/* Admin Bans */}
                                {allowedTypes.includes('admin_ban') &&
                                    ((filter === 'admin_ban') || (filter === 'all' && notifications.admin_response?.admin_ban?.length > 0)) && (
                                        <>
                                            {(filter !== 'all' || (notifications.admin_response?.admin_ban?.length > 0)) && (
                                                <div style={{ fontWeight: 'bold', marginTop: '12px', marginBottom: '8px' }}>
                                                    Admin Bans
                                                </div>
                                            )}
                                            <AdminResponse
                                                responses={notifications.admin_response?.admin_ban}
                                                readNotifications={readNotifications}
                                                setReadNotifications={setReadNotifications}
                                                onMarkAsRead={handleMarkAsRead}
                                            />
                                        </>
                                    )}
                            </div>


                        </>
                    )}
                </div>
            )}




        </div>
    );
};

export default NotificationDropdown;
